import { create } from 'zustand';
import { DEFAULT_NOISE_PARAMS, type NoiseParams } from '@wg/shared';

type ParamsState = {
  params: NoiseParams;
  set: <K extends keyof NoiseParams>(key: K, value: NoiseParams[K]) => void;
  setAll: (p: Partial<NoiseParams>) => void;
  reset: () => void;
  randomizeSeed: () => void;
};

export const useParamsStore = create<ParamsState>((set) => ({
  params: DEFAULT_NOISE_PARAMS,
  set: (key, value) => set((s) => ({ params: { ...s.params, [key]: value } })),
  setAll: (p) => set((s) => ({ params: { ...s.params, ...p } })),
  reset: () => set({ params: DEFAULT_NOISE_PARAMS }),
  randomizeSeed: () =>
    set((s) => ({
      params: { ...s.params, seed: Math.random().toString(36).slice(2, 10) },
    })),
}));
